import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["apiKey", "requestForm", "serverUrl", "operationLink"]

  static values = { documentationId: String }

  connect() {
    this.localStorageName = `documentation:${this.documentationIdValue}:api-key`
    this.#setDomApiKeyFromLocalStorage()
    this.changeAuthentication()
  }

  changeAuthentication() {
    const authentication = this.element.querySelector("[data-selected-scheme=true]")
    if (authentication === null) {
      return
    }
    const authenticationId = authentication.dataset.schemeId

    this.#setParamInOperationUrl("authentication_id", authenticationId)
    this.#setParamUrl("authentication_id", authenticationId)

    this.#setDomApiKeyFromLocalStorage()

    // Use to update the request
    const apiKey = this.apiKeyTarget.value
    this.dispatch("updatedApiKey", { detail: { apiKey: apiKey } })
    this.dispatch("changedAuthentication")
  }

  changeServer(event) {
    const server = event.currentTarget.parentElement
    const serverId = server.dataset.id

    this.#setParamInOperationUrl("server_id", serverId)
    this.#setParamUrl("server_id", serverId)

    // TODO EXPLORER: Code to move in other file
    const clickedButton = event.currentTarget
    // Firstly, the url is updated first with values in the explorer-server-variables controller,
    // then url will be shared to sendRequestController from this controller.
    this.serverUrlTarget.textContent = server.dataset.rawUrl
    this.serverUrlTarget.dataset.currentServerValues = server.dataset.serverVariables
    this.serverUrlTarget.dataset.currentServerRawUrl = server.dataset.rawUrl
    this.serverUrlTarget.dataset.currentServerId = serverId

    const serverVariablesController = this.application.getControllerForElementAndIdentifier(this.element, "explorer-server-variables")
    this.serverUrlTarget.textContent = server.dataset.rawUrl
    serverVariablesController.connect()

    this.element.querySelectorAll("button").forEach((button) => button.classList.remove("selected"))
    clickedButton.classList.add("selected")
    // until here

    this.#setDomApiKeyFromLocalStorage()

    // Use to update the request, only if operation has some ApiKey.
    if (this.#hasApiKey()) {
      const apiKey = this.apiKeyTarget.value
      this.dispatch("updatedApiKey", { detail: { apiKey: apiKey } })
    }
  }

  resetApiKey() {
    this.apiKeyTarget.value = ""
    const apiKeys = this.#retrieveApiKeysFromLocalStorage()
    const serverApiKeys = apiKeys[this.#currentServerLocalStorageKey()]
    //  Clear old string
    if ((serverApiKeys != null) && (typeof (serverApiKeys) === "object")) {
      delete apiKeys[this.#currentServerLocalStorageKey()][this.#currentAuthenticationLocalStorageKey()]
      if (Object.keys(apiKeys[this.#currentServerLocalStorageKey()]).length == 0) {
        delete apiKeys[this.#currentServerLocalStorageKey()]
      }
    }
    localStorage.setItem(this.localStorageName, JSON.stringify(apiKeys))
    this.dispatch("updatedApiKey", { detail: { apiKey: "" } })
  }

  // let users get entered tokens back when switching servers
  // TODO EXPLORER: add js helper debounce
  updateApiKey(event) {
    const apiKey = event.currentTarget.value
    if (apiKey === "") {
      return this.resetApiKey()
    }
    const apiKeys = this.#retrieveApiKeysFromLocalStorage()
    const serverApiKeys = apiKeys[this.#currentServerLocalStorageKey()]
    if ((serverApiKeys === null) || (typeof (serverApiKeys) !== "object")) {
      apiKeys[this.#currentServerLocalStorageKey()] = { }
    }
    apiKeys[this.#currentServerLocalStorageKey()][this.#currentAuthenticationLocalStorageKey()] = apiKey
    localStorage.setItem(this.localStorageName, JSON.stringify(apiKeys))
    this.dispatch("updatedApiKey", { detail: { apiKey: apiKey } })
  }

  #setParamUrl(key, value) {
    let params = new URLSearchParams(window.location.search)
    params.set(key, value)
    const newUrl = new URL(window.location)
    newUrl.search = params.toString()
    history.pushState({}, "", newUrl)
  }

  #setDomApiKeyFromLocalStorage() {
    if (!this.#hasApiKey()) {
      return
    }
    const apiKey = this.#getLocalStorageApiKey() || ""
    this.apiKeyTarget.value = apiKey
  }

  #retrieveApiKeysFromLocalStorage() {
    return JSON.parse(localStorage.getItem(this.localStorageName)) || {}
  }

  #currentServerLocalStorageKey() {
    return this.serverUrlTarget.dataset.currentServerId.trim()
  }

  #currentAuthenticationLocalStorageKey() {
    const authentication = this.element.querySelector("[data-selected-scheme=true]")
    return authentication.dataset.schemeId
  }

  #setParamInOperationUrl(key, value) {
    if (!value) {
      return
    }

    this.operationLinkTargets.forEach((operationLink) => {
      const url = new URL(operationLink.href)
      let operationLinkParams = new URLSearchParams(url.search)

      operationLinkParams.set(key, value)

      url.search = operationLinkParams.toString()
      operationLink.href = url.toString()
    })
  }

  #hasApiKey() {
    return this.apiKeyTargets.length > 0
  }

  #getLocalStorageApiKey() {
    const apiKeys = this.#retrieveApiKeysFromLocalStorage()
    const serverApiKeys = apiKeys[this.#currentServerLocalStorageKey()]
    if ((serverApiKeys != null) || (typeof (serverApiKeys) === "object")) {
      return apiKeys[this.#currentServerLocalStorageKey()][this.#currentAuthenticationLocalStorageKey()]
    }
    return null
  }
}
